import { useFpCampaignProductsService } from '@cart-services/hooks/useFpCampaignProductsService'
import { type CountryCode, type ProjectCode } from '@constants'
import { useApiCampaignActivityInfo } from '@hooks-api/fortune/useApiCampaignActivityInfo'
import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import ChildClientFAQ from '../../components/child-client-faq'
import { TheCampaignHeader } from '../../components/TheCampaignHeader'
import style from '../../style/pages/client-faq.module.scss'
import { loadFaqClientData } from '../client-data-import'
import { useProductCatalog } from './product-catalog/components/ProductCatalogProvider/useProductCatalog'

const ClientFAQ = () => {
  const brand = 'dcs'
  const { t } = useTranslation()

  const { campaignCode } = useProductCatalog()
  const { destructuredData: exhibitorSettings } = useApiCampaignActivityInfo(campaignCode)
  const campaignId = exhibitorSettings?.campaign_id ?? undefined
  const { region: countryCode } = exhibitorSettings || {}
  const { projectCode } = useFpCampaignProductsService(campaignCode)

  const country = exhibitorSettings?.region.toLowerCase() || 'hk'
  const faq = useRef<FAQ.FAQData>(loadFaqClientData(country))

  return (
    <main className={style.main}>
      <TheCampaignHeader projectCode={projectCode as ProjectCode} campaignId={campaignId as number} countryCode={countryCode as CountryCode} />
      <div className={style['faq-wrapper']}>
        <div className={style.title}>{t('menu.faq')}</div>
        {faq.current[brand]?.map(item => (
          <ChildClientFAQ key={item.title} mainData={item} />
        ))}
      </div>
    </main>
  )
}

export default ClientFAQ
